import { render } from "./CustomerProfileCreate.vue?vue&type=template&id=05cd1ed4"
import script from "./CustomerProfileCreate.vue?vue&type=script&lang=js"
export * from "./CustomerProfileCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__